export default function Footer() {
  return (
    <footer className="py-4 mt-8 border-t">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <p className="mb-0">Built with Next.js, Deployed on Cloudflare Pages</p>
          <p className="my-0">ejrbdi@gmail.com</p>
          <p className="my-0">Copyright © 2024 - 2024 ydk1204</p>
        </div>
      </div>
    </footer>
  )
}
